import { ScreenQuestionProps } from './types';

type NoticePeriodEntry = readonly [label: string, weight: number];

const NOTICE_PERIOD_ENTRIES: ReadonlyArray<NoticePeriodEntry> = [
  ['Immediate', 0],
  ['1 week', 1],
  ['2 weeks', 2],
  ['3 weeks', 3],
  ['1 month', 4],
  ['2 months', 8],
  ['3 months', 12],
  ['Over 3 months', 16],
] as const;

export const NOTICE_PERIOD_VALUE_MAP = NOTICE_PERIOD_ENTRIES.reduce<Record<string, number>>(
  (acc, [label, weight]) => {
    acc[label] = weight;
    return acc;
  },
  {},
);

export const NOTICE_PERIOD_OPTIONS = NOTICE_PERIOD_ENTRIES.map(([label]) => ({
  label,
  value: label,
}));

const BASE_NOTICE_PERIOD_QUESTION: ScreenQuestionProps = {
  title: 'Notice Period',
  question: 'What is your notice period?',
  type: 'NoticePeriod',
  category: 'PreDefined',
  answerType: 'SingleChoice',
  valueMap: NOTICE_PERIOD_VALUE_MAP,
  options: NOTICE_PERIOD_OPTIONS,
};

export const NOTICE_PERIOD_PREDEFINED_QUESTION: ScreenQuestionProps = {
  ...BASE_NOTICE_PERIOD_QUESTION,
  required: true,
};

export const createNoticePeriodQuestion = (
  overrides: Partial<ScreenQuestionProps> = {},
): ScreenQuestionProps => ({
  ...BASE_NOTICE_PERIOD_QUESTION,
  required: false,
  expectedAnswer: '',
  idealWeight: undefined,
  ...overrides,
});
